/** Per backend rules: ownership/operator on components only when standalone (off-wing). */
export const isComponentAttachedToAirframe = (
  attachedToAirframe?: string | null,
  attachmentLocation?: string | null
): boolean =>
  Boolean(
    attachedToAirframe?.trim() && attachmentLocation?.trim()
  );

export const shouldShowComponentOwnershipFields = (
  attachedToAirframe?: string | null,
  attachmentLocation?: string | null
): boolean => !isComponentAttachedToAirframe(attachedToAirframe, attachmentLocation);

/** Airframes can show ownership fields (status/operator); visibility is controlled by tenant display preferences. */
export const shouldShowAirframeOwnershipFields = (): boolean => true;
